orders-info.order-props
  h4.mb-4.title
    | { opts.locale.labels.job_no } { opts.job_no } &nbsp;
    span.badge.badge-info.order_type(if="{opts.is.casting_biz}") { opts.locale.casting_biz }
    span.badge.badge-info.order_type(if="{opts.is.ct_biz}") { opts.locale.ct_biz }
    span.badge.badge-primary.order_type(if="{opts.is.new_order}") { opts.locale.new_order }
    span.badge.badge-success.order_type(if="{opts.is.repeater}")   { opts.locale.repeater }
    span.badge.badge-warning.order_type(if="{opts.is.changing}")   { opts.locale.changing }
    span.badge.badge-inverse-default.status(if="{opts.is.information}") { opts.locale.information}
    span.badge.badge-default.status(if="{opts.is.unofficial}") { opts.locale.unofficial}
    span.badge.badge-warning.status(if="{opts.is.received}") { opts.locale.received}
    span.badge.badge-inverse-primary.status(if="{opts.is.pending}") { opts.locale.pending}
    span.badge.badge-inverse-danger.secondary.status(if="{opts.is.failed}") { opts.locale.failed}
    span.badge.badge-success.status(if="{opts.is.done}") { opts.locale.done}
  orders-warnings(if="{opts.orders_warnings_scope}" tag-scope="{opts.orders_warnings_scope}")
  //- クライアント名　担当者名
  .row.mb-4
    .col-12.col-md-4.mb-2
      | { opts.locale.labels.client_name }
    .col-12.col-md-8.mb-2
      b { opts.client_name }
      br(if="{ opts.client_person_name }")
      span(if="{opts.client_person_name}") { opts.client_person_name }
  //- 商品名　品番
  .row.mb-4
    .col-12.col-md-4.mb-2
      | { opts.locale.labels.product_name }
    .col-12.col-md-8.mb-2
      b.product_name { opts.product_name }
      br(if="{ opts.product_id }")
      span.product_id(if="{ opts.product_id }") { opts.product_product_id }
      pre.products_memo(if="{opts.product_memo}") { opts.product_memo }
  //- 営業担当者
  .row.mb-4
    .col-12.col-md-4.mb-2
      | { opts.locale.labels.user_name }
    .col-12.col-md-8.mb-2
      b { opts.user_name }
  hr.mb-4
  //- 必要数
  .row.mb-4
    .col-12.col-md-4.mb-2
      | { opts.locale.labels.required_num }
    .col-12.col-md-8.mb-2
      span.badge.badge-danger(if="{ opts.required_num <= 0}") !
      b { opts.required_num }
  //- 締め切り
  .row.mb-4
    .col-12.col-md-4.mb-2
      | { opts.locale.labels.deadline }
    .col-12.col-md-8.mb-2
      span.badge.badge-danger(if="{ !opts.deadline }") !
      i.feather.icon-calendar
      b.text-danger { opts.deadline }
  //- 初回納品日
  .row.mb-4
    .col-12.col-md-4.mb-2
      | { opts.locale.labels.brifing_date }
    .col-12.col-md-8.mb-2
      i.feather.icon-calendar
      span { opts.brifing_date }
  hr.mb-4
  //- 顧客希望納期
  .row.mb-4
    .col-12.col-md-4.mb-2
      | { opts.locale.labels.deadline_preferred }
    .col-12.col-md-8.mb-2
      i.feather.icon-calendar
      span { opts.deadline_preferred }
  //- 全体の指示
  .row.mb-4
    .col-12.col-md-4.mb-2
      | { opts.locale.labels.description }
    .col-12.col-md-8.mb-2.description
      pre.desc { opts.description }
  //- 関連ファイル
  hr.mb-4
  forms-orders-files(tag-scope="forms_orders_files")
  hr.mb-4
  //- フェーズごとの情報
  .row.mb-4.phase(each="{opts.phases}")
    //- unit_price
    .col-12.col-md-4.mb-2(if="{unit_price}")
      span.index(style="border-color: {colorcode}") { unit_price.label }
    .col-12.col-md-8.mb-2(if="{unit_price}")
      | { Number(unit_price.value).toLocaleString() } { parent.opts.locale.unit_price_unit }
    //- material
    .col-12.col-md-4.mb-2(if="{material}")
      span.index(style="border-color: {colorcode}") { material.label }
    .col-12.col-md-8.mb-2(if="{material}")
      | { material.value }
    //- heat_treatment
    .col-12.col-md-4.mb-2(if="{heat_treatment}")
      span.index(style="border-color: {colorcode}") { heat_treatment.label }
    .col-12.col-md-8.mb-2(if="{heat_treatment}")
      | { heat_treatment.value }
    //- phase_fixed
    .col-12.col-md-4.mb-2
      span.index(style="border-color: {colorcode}") { phase_fixed.label }
    .col-12.col-md-8.mb-2
      div.d-flex(if="{phase_fixed.value}")
        span.circle-icon
          span.badge.badge-success
            i.fas.fa-check
        span 確認済み
      div.d-flex(if="{!phase_fixed.value}")
        span.circle-icon
          span.badge.badge-warning
            i.fas.fa-exclamation
        span 確認中
    //- description
    .col-12.col-md-4.mb-2
      span.index(style="border-color: {colorcode}") { description.label }
    .col-12.col-md-8.mb-2
      pre.desc
        | { description.value }
    // 検査固有の情報
    .check.todo.col-12.col-md-4.mb-2(if="{check}")
      span.index(style="border-color: {colorcode}") { check.todo.label }
    .col-12.col-md-8.mb-2(if="{check}")
      div.d-flex.flex-wrap
        div.mr-3(each="{item, key in check.todo.items}" if="{item.value}")
          i.fas.fa-check-circle.text-secondary.mr-1
          | {item.label}
    .check.reports.col-12.col-md-4.mb-2(if="{check}")
      span.index(style="border-color: {colorcode}") { check.reports.label }
    .col-12.col-md-8.mb-2(if="{check}")
      div.d-flex.flex-wrap
        div.mr-3(each="{item, key in check.reports.items}" if="{item.value}")
          i.fas.fa-check-circle.text-secondary.mr-1
          span {item.label}
          span.badge.badge-info(if="{item.number}") { item.number } 台
    .check.special_reports_customer.col-12.col-md-4.mb-2(if="{check}")
      span.index(style="border-color: {colorcode}") { check.special_reports_customer.label }
    .check.special_reports_customer.col-12.col-md-8.mb-2(if="{check}")
      div.d-flex.flex-wrap
        div.mr-3(each="{filename in check.special_reports_customer.value}")
          i.fas.fa-check-circle.text-secondary.mr-1
          span {filename}
    .check.special_reports_other.col-12.col-md-4.mb-2(if="{check}")
      span.index(style="border-color: {colorcode}") { check.special_reports_other.label }
    .check.special_reports_other.col-12.col-md-8.mb-2(if="{check}")
      div.d-flex.flex-wrap
        div.mr-3(each="{filename in check.special_reports_other.value}")
          i.fas.fa-check-circle.text-secondary.mr-1
          span {filename}
    .check.memo_for_reports.col-12.col-md-4.mb-2(if="{check}")
      span.index(style="border-color: {colorcode}") { check.memo_for_reports.label }
    .check.memo_for_reports.col-12.col-md-4.mb-2(if="{check}")
      pre.desc
        | { check.memo_for_reports.value }
    // 発送固有の情報
    .delivery.attachments.col-12.col-md-4.mb-2(if="{delivery}")
      span.index(style="border-color: {colorcode}") { delivery.attachments.label }
    .delivery.attachments.col-12.col-md-8.mb-2(if="{delivery}")
      .fixed_status
        div.d-flex(if="{delivery.attachments.fixed_status.value}")
          span.circle-icon
            span.badge.badge-success
              i.fas.fa-check
          span 確認済み
        div.d-flex(if="{!delivery.attachments.fixed_status.value}")
          span.circle-icon
            span.badge.badge-warning
              i.fas.fa-exclamation
          span 確認中
      .attachments-items
        div.d-flex.flex-wrap
          div.mr-3(each="{key in delivery.attachments.simple_attachments}" if="{delivery.attachments.items[key].value}")
            i.fas.fa-check-circle.text-secondary.mr-1
            span {delivery.attachments.items[key].label}
        div.inspection_table(if="{delivery.attachments.items.inspection_table.value}")
          i.fas.fa-check-circle.text-secondary.mr-1
          span {delivery.attachments.items.inspection_table.label}
          span(class="label {delivery.attachments.items.inspection_table.klass} ml-1") {delivery.attachments.items.inspection_table.how_to_send}
          pre {delivery.attachments.items.inspection_table.memo_for_inspection}
        div.receipt_jmc_excel(if="{delivery.attachments.items.receipt_jmc_excel.value}")
          | {console.log(delivery.attachments.items.receipt_jmc_excel.delivery_pattern)}
          i.fas.fa-check-circle.text-secondary.mr-1
          span {delivery.attachments.items.receipt_jmc_excel.label}
          span(class="label {delivery.attachments.items.receipt_jmc_excel.klass} ml-1") {delivery.attachments.items.receipt_jmc_excel.delivery_pattern}
          pre {delivery.attachments.items.receipt_jmc_excel.to}
        div.receipt_by_system(if="{delivery.attachments.items.receipt_by_system.value}")
          i.fas.fa-check-circle.text-secondary.mr-1
          span {delivery.attachments.items.receipt_by_system.label}
          span(class="label {delivery.attachments.items.receipt_by_system.klass} ml-1") {delivery.attachments.items.receipt_by_system.delivery_pattern}
          pre {delivery.attachments.items.receipt_by_system.to}
        div.bills_by_system(if="{delivery.attachments.items.bills_by_system.value}")
          i.fas.fa-check-circle.text-secondary.mr-1
          span {delivery.attachments.items.bills_by_system.label}
          span.label.label-inverse-info-border.ml-1 {delivery.attachments.items.bills_by_system.bills_pattern}
      div.mb-3 { delivery.other_attachments.label }
      div.d-flex.flex-wrap.mb-3
        div.mr-3(each="{item in delivery.other_attachments.value}")
          i.fas.fa-check-circle.text-secondary.mr-1
          span.label.label-inverse-info(if="{item.inclusion}")
            | 同梱
          span.label.label-inverse-warning(if="{!item.inclusion}")
            | 別送
          span {item.filename}
      div.mb-3 { delivery.memo_for_delivery.label}
      div.mb-3
        pre.desc
          | { delivery.memo_for_delivery.value }
    .delivery.other-attachments.col-12.col-md-4.mb-2(if="{delivery}")
      span.index(style="border-color: {colorcode}") { delivery.attachments_for_circle.label }
    .delivery.other-attachments.col-12.col-md-8.mb-2(if="{delivery}")
      div.d-flex.flex-wrap
        div.mr-3(if="{delivery.attachments_for_circle.test_bar}")
          i.fas.fa-check-circle.text-secondary.mr-1
          span 試験棒
        div.mr-3(each="{item in delivery.attachments_for_circle.value}")
          i.fas.fa-check-circle.text-secondary.mr-1
          span {item}
          
  hr.mb-4(if="{opts.useUnder || opts.useStatus}")
  .row.mb-4(if="{opts.useUnder}")
    .col-12
      forms-orders-under(tag-scope="forms_orders_under" refresh="true")
  .row.mb-4(if="{opts.useStatus}")
    .col-12
      forms-orders-status(tag-scope="forms_orders_status" refresh="true")
  hr.mb-4(if="{opts.useApprovals}")
  .row.mb-4.basic-approvals(if="{opts.useApprovals}")
    .col-12
      orders-basic-approvals(tag-scope="orders_basic_approvals")
  //- 
  script(type="typescript").
    this.mixin('orders.info');
  style(scoped).
    .title .badge {
      display: inline-block;
      margin-right: 4px;
    }
    .phase span.index {
      display: inline-block;
      border-bottom: 4px solid #CCC;
    }
    forms-orders-under inputs-submit,
    forms-orders-status inputs-submit{
      display: none;
    }
    .circle-icon .badge{
      width: 20px;
      height: 20px;
      text-align: center;
      vertical-align: middle;
      display: table-cell;
      padding: 0;
    }
    .circle-icon + span {
      margin-left: .5rem;
      display: inline-block;
    }
    .circle-icon i {
      font-size: 10px;
    }
